// sales reports routes
const ProjectConsumptionSummary = () =>
  import("./index.vue");
const ProjectOrdersReport = () =>
  import("./project-orders.vue");
const ProductsOrderedReport = () =>
  import("./ordered-products.vue");
const ProjectOrderPreview = () =>
  import("./order-preview.vue");

export default [
  {
    path: "/project-consumption-reports",
    component: ProjectConsumptionSummary,
  },
  {
    path: "/project-orders-summary",
    component: ProjectOrdersReport,
  },
  {
    path: "/products-consumption-report",
    component: ProductsOrderedReport,
  },
  {
    path: "project-order-details/:id",
    component: ProjectOrderPreview,
  },
];
